import { useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, CheckCircle2 } from "lucide-react";

const fmtDate = (d) => {
  try { return new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }); }
  catch { return ""; }
};

// Public, non-blocking "confirm receipt" control for shared condition reports.
export function AcknowledgeReceipt({ endpoint, initialAcknowledgedAt }) {
  const [ackAt, setAckAt] = useState(initialAcknowledgedAt || null);
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}${endpoint}`);
      setAckAt(data.acknowledged_at);
    } catch (e) {
      console.error("acknowledge receipt failed", e);
      toast.error("Couldn't confirm — try again.");
    } finally {
      setBusy(false);
    }
  };

  if (ackAt) {
    return (
      <div data-testid="receipt-confirmed" className="mt-6 rounded-2xl border border-[#A7F3D0] bg-[#ECFDF5] p-4 flex items-center gap-2.5">
        <CheckCircle2 size={18} className="text-[#177245] shrink-0" />
        <p className="text-sm font-semibold text-[#177245]">Receipt confirmed {fmtDate(ackAt)}</p>
      </div>
    );
  }

  return (
    <div className="mt-6 rounded-2xl border border-[#E2E8F0] bg-white p-4" data-testid="acknowledge-receipt">
      <button
        data-testid="confirm-receipt-btn"
        onClick={confirm}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-xl bg-brand hover:bg-brand-hover text-white text-sm font-semibold px-4 py-2.5 transition-colors disabled:opacity-60"
      >
        {busy && <Loader2 size={16} className="animate-spin" />}
        Confirm you've received this report
      </button>
      <p className="mt-2 text-xs text-[#94A3B8] leading-relaxed">
        This records the date you viewed the condition report. It does not indicate agreement with its contents.
      </p>
    </div>
  );
}
